import type { BrowserFallbackRegistry } from './types'

export const overlayBrowserFallbacks: BrowserFallbackRegistry = {
  overlay: {
    getClipboardContents: async () => {
      try {
        if (navigator.clipboard?.readText) {
          const text = await navigator.clipboard.readText()
          if (text && text.trim().length > 0) {
            return { type: 'text', value: text }
          }
        }
      } catch (error) {
        console.warn('[browser-runtime] Failed to read clipboard contents', error)
      }
      return undefined
    },
    getCursorScreenPoint: () => ({ x: 0, y: 0 }),
    getMousePosition: () => ({ x: 0, y: 0 }),
    screenshotWindow: () => undefined,
    getActiveDisplayScreenshot: () => undefined,
    getScreenshotWindows: () => [],
    getDisplayScreenshots: () => [],
    getAppIcon: () => null,
    compareContext: () => true,
    requestContext: () => null,
    requestContextForWindow: () => null,
    writeTextToClipboard: async (payload) => {
      try {
        const data = payload as { text?: string; html?: string } | undefined
        const text = data?.text ?? ''
        const html = data?.html

        if (html && typeof ClipboardItem !== 'undefined') {
          const items = new ClipboardItem({
            'text/plain': new Blob([text], { type: 'text/plain' }),
            'text/html': new Blob([html], { type: 'text/html' }),
          })
          await navigator.clipboard.write([items])
        } else if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text)
        }
      } catch (error) {
        console.warn('[browser-runtime] Failed to write to clipboard', error)
      }
    },
    compressBase64ImageToJpeg: (payload) => {
      const request = payload as { base64Image?: string } | undefined
      return request?.base64Image ?? ''
    },
    compressBase64ImageToPng: (payload) => {
      const request = payload as { base64Image?: string } | undefined
      return request?.base64Image ?? ''
    },
  },
}
